<div (click)='$event.stopPropagation()' class='modal-body modal-body-history'>
  <div class="header">
    <h4 class='modal-title'>
      {{ "TITLE.DOCUMENT_HISTORY" | translate }}
    </h4>
    <form class="history-filter-container" [formGroup]="filterForm">
      <pt-input-timestamp
        [label]="'LABELS.FROM' | translate"
        [showTimePicker]="false"
        [isRequired]="true"
        formControlName='from'>
      </pt-input-timestamp>

      <div class="history-filter-select-container">
        <label class="form-label position-relative">
          {{'LABELS.DURATION' | translate}}
        </label>
        <ng-select
          [items]="durationValue"
          [bindValue]="'value'"
          [bindLabel]="'label'"
          [multiple]="false"
          [closeOnSelect]="true"
          formControlName="duration"
          [clearable]="false">
        </ng-select>
      </div>

      <button
        type='button' class='btn btn-outline-primary btn-sm btn-find'
        [disabled]="status === 'LOADING' || filterForm.invalid"
        (click)='reloadEventTable();'>
        <pt-icon [key]='IconFind'></pt-icon>
        {{ 'BUTTON.FIND' | translate }}
      </button>
    </form>
  </div>

  <ng-container [ngSwitch]="status">
    <ng-container *ngSwitchCase="'LOADING'">
      <div class="doc-history-message-container">
        <div class="spinner-border spinner-border-sm me-2 text-muted" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        {{ 'MESSAGE.LOADING' | translate }}
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'ERROR'">
      <div class="doc-history-message-container">
        <div class='d-flex flex-column align-items-center text-muted'>
          <pt-icon [iconType]='IONIC_ICON' [key]='IconError' [size]='40'></pt-icon>
          <span [innerHTML]="'MESSAGE.UNEXPECTED_ERROR_OCCURRED' | translate"></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'EMPTY'">
      <div class="doc-history-message-container">
        <div class='d-flex flex-column align-items-center text-muted'>
          <pt-icon [iconType]='IONIC_ICON' [key]='IconEmpty' [size]='40' style="margin-bottom: 10px;"></pt-icon>
          <span>{{ "MESSAGE.NO_DATA_TO_SHOW" | translate }}</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'DATA'">
      <ag-grid-angular
        *ngIf='columnDefs && gridOptions'
        style='width: 100%; height: 400px;'
        class='ag-theme-balham'
        [rowData]='data'
        [columnDefs]='columnDefs'
        [gridOptions]='gridOptions'>
      </ag-grid-angular>
    </ng-container>
  </ng-container>

  <ng-template #nameCol let-node>
    <pt-image-renderer
      [label]='node.row.resourceName'
      [type]='type'
    ></pt-image-renderer>
  </ng-template>

  <ng-template #operationCol let-node>
    <pt-operation-type-badge-view
      [operationType]="node.row.operationType">
    </pt-operation-type-badge-view>
  </ng-template>
</div>

<div (click)='$event.stopPropagation()' class='modal-footer'>
  <button (click)='activeModal.close(false); $event.stopPropagation()' class='btn btn-outline-secondary btn-sm'
          type='button'>
    {{ 'BUTTON.CLOSE' | translate }}
  </button>
</div>

